import PropTypes from 'prop-types';

export default {
	apiBaseUrl: PropTypes.string,
	apiBankId: PropTypes.string,
	brandId: PropTypes.string,
	isSavingsPotsEnabled: PropTypes.bool,
	isSpendingsEnabled: PropTypes.bool,
	isTaggingEnabled: PropTypes.bool,
	isFinancialStoryEnabled: PropTypes.bool,
	isContactDetailsEnabled: PropTypes.bool,
	isHelpDemoEnabled: PropTypes.bool,
	isSweepsEnabled: PropTypes.bool,
	isNBAEnabled: PropTypes.bool,
	isNicknameAmendEnabled: PropTypes.bool,
	callValidate3DTimelimit: PropTypes.number,
	disableAnalytics: PropTypes.bool,
	trackingId: PropTypes.string,
	disableNavigationWarning: PropTypes.bool,
	enableWindowStubs: PropTypes.bool,
	stubApiData: PropTypes.bool,
	isSecureMessageEnabled: PropTypes.bool,

	targetScope: PropTypes.shape({
		unknown: PropTypes.number,
		notAuthed: PropTypes.number,
		authentication: PropTypes.number,
		login: PropTypes.number,
	}),
	websiteBaseDirectory: PropTypes.string,
	autoLoginTimeout: PropTypes.number,
	nextTaskCheckInterval: PropTypes.number,
	defaultAutoSaveInterval: PropTypes.number,
	shortAutoSaveInterval: PropTypes.number,
	publicKeyExpiry: PropTypes.number,
	tokenInactivityTimeout: PropTypes.number,
	statementsURl: PropTypes.string,
	idvRedirectURL: PropTypes.string,
	redirectToBOW: PropTypes.string,
	manageContactDetailsLink: PropTypes.string,
	marketingPreferenceLink: PropTypes.string,
	manageCredentialLink: PropTypes.string,
	malwareurl: PropTypes.string,
	eGainLiveServerURL: PropTypes.string,
	coBrowseScriptID: PropTypes.string,
	domainName: PropTypes.string,
	secureMessageURL: PropTypes.string,
	chapsPaymentLimit: PropTypes.number,
};
